export default [
  {
    name: 'visa',
    path: '/visa',
    component: resolve => require(['Views/Visa'], resolve),
    meta: {
      include: ['Visa'],
      index: 1
    }
  },
  {
    name: 'visaList',
    path: '/visa/list',
    component: resolve => require(['Views/Visa/visaQuery/visaList'], resolve),
    meta: {
      include: ['Visa', 'VisaList'],
      index: 2
    }
  },
  {
    name: 'visaDetail',
    path: '/visa/detail',
    component: resolve => require(['Views/Visa/visaQuery/visaDetail'], resolve),
    meta: {
      include: ['Visa', 'VisaList', 'VisaDetail'],
      index: 3
    }
  },
  {
    name: 'visaEdit',
    path: '/visa/edit',
    component: resolve => require(['Views/Visa/visaQuery/visaEdit'], resolve),
    meta: {
      include: ['Visa', 'VisaList', 'VisaDetail', 'VisaEdit'],
      index: 4
    }
  },
  {
    name: 'visaCmp',
    path: '/visa/cmp/:id',
    component: resolve => require(['Views/Visa/visaOrder/Cmp'], resolve),
    props: true,
    meta: {
      include: [],
      index: 5
    }
  },
  {
    name: 'visaOrder',
    path: '/visa/orderDetail/:id',
    component: resolve => require(['Views/Visa/visaOrder/Detail'], resolve),
    props: true,
    meta: {
      include: [],
      index: 6
    }
  },
  {
    name: 'visaOrderService',
    path: '/visa/OrderService',
    component: resolve => require(['Views/Visa/visaOrder/OrderService'], resolve),
    props: true,
    meta: {
      include: ['Visa', 'VisaList', 'VisaDetail', 'VisaEdit', 'visaOrderService'],
      index: 6
    }
  }
]